import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import PeopleFaces from "../../../assests/images/top-rated-award-more-details/people-faces.webp";
import PeopleLightFaces from "../../../assests/images/top-rated-award-more-details/people-light-faces.webp";
import BenefitsBeingImage from "../../../assests/images/badge-lg.webp";
import ReviewSerch from "../../../components/common/reviewSerchBox";
import SocialMediaRequests from "../../../components/common/SocialMediaRequests/SocialMediaRequests";
import TopRatedStatusImage from "../../../assests/images/top-rated-award-more-details/top-rated-status.webp";
import{
    YourBadgeSection,
    BadgeWrap,
    BadgeContent,
    BadgeTitle,
    BadgeText,
    BadgeTextSpan,
    BadgeList,
    ListText,
    BadgeImage,
    BeingSection,
    BenefitsBeingImageWrap,
    BenefitsBeingTitle,
    BenefitsBeingList,
    BenefitsBeingListText,
    QualifySection,
    QualifyWrap,
    QualifyTitle,
    QualifyText,
    ClaimYourSection,
    ClaimYourBox,
    ClaimYourBoxTitle,
    ClaimYourSocialMedia,
    TopRatedStatusBox,
    RatedStatusContent,
    RatedStatusText,
    RatedStatusList,
    RatedStatusListText,
    RatedStatusImage,
} from "./detailsStyle"
import { yearBadgeHandler } from "../../../redux/slices/yearBadge/yearBadge-slice";
import { useDispatch } from "react-redux";

const TopRatedAwardDetails = ({qualifySectionRef}:any) => {
    const dispatch:any = useDispatch()

    useEffect(() =>{
        dispatch(yearBadgeHandler())
    },[])

    return (
        <>
            <YourBadgeSection>
                <Container className="cont-w">
                    <Row>
                        <Col sm="12">
                            <BadgeWrap>
                                <BadgeContent>
                                    <BadgeTitle>Earn Your 2024 Badge</BadgeTitle>

                                    <BadgeText><BadgeTextSpan>72%</BadgeTextSpan>of people say that the presence of a badge increases their likelihood of giving</BadgeText>
                                    <BadgeList>
                                        <ListText>Gather Inspirational Stories</ListText>
                                        <ListText>Gain Recognition & Exposure</ListText>
                                        <ListText>Increase Donor Trust</ListText>
                                    </BadgeList>
                                </BadgeContent>

                                <BadgeImage>
                                    <Image src={PeopleFaces} alt="People Faces" />
                                    <Image src={PeopleLightFaces} alt="People Light Faces" />
                                </BadgeImage>

                            </BadgeWrap> 
                        </Col>
                    </Row>
                </Container>
            </YourBadgeSection>

            <BeingSection>
                <Container className="cont-w">
                    <Row>
                        <Col md="8">
                            <BenefitsBeingTitle>Benefits of Being Top-Rated</BenefitsBeingTitle>
                            <BenefitsBeingList>
                                <BenefitsBeingListText>You'll receive the 2024 Top Rated Badge, Certificate, Press Kit and Marketing Materials to include in your donor letters and on your website</BenefitsBeingListText>
                                <BenefitsBeingListText>You will be included in our 2024 Top-Rated List and 2024 #GivingTuesday Guide, and will receive promotion throughout the year and during the fundraising season in conjunction with #GivingTuesday</BenefitsBeingListText>
                                <BenefitsBeingListText>Winners will be widely promoted via social media, public relations, newsletters and emails</BenefitsBeingListText>
                                <BenefitsBeingListText>You will receive special designation on the GreatNonprofits site</BenefitsBeingListText>
                                <BenefitsBeingListText>You'll strengthen trust amongst current and prospective donors who use the Top-Rated list as a tool for vetting nonprofits and finding organizations to support</BenefitsBeingListText>
                            </BenefitsBeingList>
                        </Col>
                        <Col md="4">
                            <BenefitsBeingImageWrap>
                                <Image src={BenefitsBeingImage} alt="badge-lg" />
                            </BenefitsBeingImageWrap>
                        </Col>
                    </Row>
                </Container>
            </BeingSection>
            <QualifySection ref={qualifySectionRef}>        
                <Container className="cont-w" id="qualify">
                    <Row>
                        <Col sm="12">
                            <QualifyWrap>
                                <QualifyTitle>How to Qualify</QualifyTitle>
                                <QualifyText>The Top-Rated Awards run from January 1 to December 31.</QualifyText>
                                <QualifyText>Claim your nonprofit</QualifyText>
                                <QualifyText>Invite clients, donors & volunteers to share their story</QualifyText>
                                <QualifyText>Get 10 positive stories within the campaign period</QualifyText>
                                <QualifyText>Maintain an average of 3.5+ stars.</QualifyText>
                            </QualifyWrap>
                        </Col>
                    </Row>
                </Container>
            </QualifySection>

            <ClaimYourSection>
                <Container className="cont-w">
                    <Row>
                        <Col lg="12">
                            <ClaimYourBox>
                                <ClaimYourBoxTitle>1. Claim Your Nonprofit</ClaimYourBoxTitle>
                                <ReviewSerch/>    
                            </ClaimYourBox>
                        </Col>
                        <Col lg="12">
                            
                        <ClaimYourBox>
                            <ClaimYourBoxTitle>2. Invite Clients, Donors & Volunteers</ClaimYourBoxTitle>
                            <ClaimYourSocialMedia>
                                <SocialMediaRequests/>
                                <SocialMediaRequests/>
                                <SocialMediaRequests/>
                            </ClaimYourSocialMedia>
                        </ClaimYourBox>
                        </Col>
                        <Col lg="12">
                            <ClaimYourBox>
                                <ClaimYourBoxTitle>3. Show Off Your Top-Rated Status</ClaimYourBoxTitle>
                                <TopRatedStatusBox>
                                    <RatedStatusContent>
                                        <RatedStatusText>All 2024 Top-Rated Nonprofits will get a Top-Rated certificate, and a FREE Top-Rated badge on their GreatNonprofits profile.</RatedStatusText>
                                        <RatedStatusList>
                                            <RatedStatusListText>Direct mail</RatedStatusListText>
                                            <RatedStatusListText>Annual reports</RatedStatusListText>
                                            <RatedStatusListText>Organization webpage</RatedStatusListText>
                                            <RatedStatusListText>Newsletters</RatedStatusListText>
                                            <RatedStatusListText>Donation page</RatedStatusListText>
                                            <RatedStatusListText>Email signature</RatedStatusListText>
                                            <RatedStatusListText>Social media</RatedStatusListText>
                                            <RatedStatusListText>Display it in your office</RatedStatusListText>
                                        </RatedStatusList>
                                        <RatedStatusText>This badge can be used on your own website and marketing materials and will show in search results on GreatNonprofits.org and on your nonprofit's profile page.</RatedStatusText> 
                                    </RatedStatusContent>
                                    <RatedStatusImage>
                                        <Image src={TopRatedStatusImage} alt="Top Rated Status Image" />
                                    </RatedStatusImage>
                                </TopRatedStatusBox>
                            </ClaimYourBox>
                        </Col>
                    </Row>
                </Container>
            </ClaimYourSection>
        </>
    )
};
export default TopRatedAwardDetails;